/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { termsEditorCommon as terms } from "../../terms/common";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "endpoint",
		label: terms.mainMenu.sectionCreate.apiEndpoint.label,
		tooltip: terms.mainMenu.sectionCreate.apiEndpoint.tooltip,
		icon: "mdi/api",
		flags: [ "primary" ],
		order: 60,
		commandId: "endpointEditor.create.open"
	});
}
